import {
  BtnLanguage,
  LanguageBox,
  LanguageListBox,
  PolicyArticleTitle,
  PolicyContainer,
  PolicyHyphenList,
  PolicyList,
  PolicySectionTitle,
  PolicyTable,
  PolicyText,
  PolicyTitle,
  PolicyVersion,
  StyledIconDropdown,
  StyledIconGlobal,
} from "styles/PolicyCommon";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const PrivacyId = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onLanguageClick = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    document.documentElement.lang = "id";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <LanguageBox isOpen={isOpen}>
        <BtnLanguage onClick={onLanguageClick}>
          <StyledIconGlobal />
          ID
          <StyledIconDropdown />
        </BtnLanguage>
        <LanguageListBox>
          <ul>
            <li>
              <Link to="/policy/en/privacy">EN</Link>
            </li>
            <li>
              <Link to="/policy/ja/privacy">JA</Link>
            </li>
            <li>
              <Link to="/policy/vi/privacy">VI</Link>
            </li>
            <li>
              <Link to="/policy/th/privacy">TH</Link>
            </li>
            <li className="selected">
              <em>ID</em>
            </li>
            <li>
              <Link to="/policy/es/privacy">ES</Link>
            </li>
          </ul>
        </LanguageListBox>
      </LanguageBox>

      <PolicyTitle>Kebijakan Privasi pregnancy&amp;baby</PolicyTitle>

      <PolicyVersion>
        Tanggal Berlaku: [21 September 2026]
        <br />
        Terakhir Diperbarui: [25 Agustus 2026]
      </PolicyVersion>
      <PolicyText>
        Connecti Co., Ltd. (selanjutnya disebut “Connecti”, “Perusahaan”, atau
        “kami”) menghormati privasi pengguna <strong>pregnancy&amp;baby</strong>
        dan menganggap perlindungan serta pengelolaan Data Pribadi pengguna
        secara tepat dan aman sebagai tanggung jawab yang penting.
      </PolicyText>
      <PolicyText>
        Kebijakan Privasi ini menjelaskan jenis Data Pribadi yang kami
        kumpulkan, tujuan pemrosesannya, kondisi di mana data dapat dibagikan
        atau ditransfer, jangka waktu penyimpanan data, serta hak pengguna
        sehubungan dengan Data Pribadi mereka.
      </PolicyText>
      <PolicyText>
        Kebijakan Privasi ini berlaku untuk aplikasi seluler{" "}
        <strong>pregnancy&amp;baby</strong>, situs web, serta produk, fitur, dan
        layanan terkait (secara bersama-sama disebut “Layanan”).
      </PolicyText>
      <PolicyText>
        Kami dapat mengubah Kebijakan Privasi ini apabila diperlukan. Jika
        terdapat perubahan penting, kami akan memberi tahu pengguna melalui
        Layanan, email, atau metode lain yang sesuai sebagaimana diwajibkan oleh
        hukum yang berlaku. Jika diwajibkan oleh hukum, kami akan memperoleh
        persetujuan pengguna atas perubahan tersebut.
      </PolicyText>

      <PolicySectionTitle>
        1. Data Pribadi yang Kami Kumpulkan
      </PolicySectionTitle>
      <PolicyText>
        Kami dapat mengumpulkan data yang diberikan langsung oleh pengguna, data
        yang dikumpulkan secara otomatis selama penggunaan Layanan, serta
        informasi tertentu yang diberikan melalui layanan autentikasi pihak
        ketiga.
      </PolicyText>

      <PolicyArticleTitle>1.1 Informasi Akun dan Profil</PolicyArticleTitle>
      <PolicyText>
        Saat pengguna membuat atau menggunakan akun, kami dapat mengumpulkan:
      </PolicyText>
      <PolicyHyphenList>
        <li>Alamat email</li>
        <li>Tahun lahir</li>
        <li>Nama panggilan</li>
        <li>Foto profil</li>
        <li>Wilayah tempat tinggal</li>
        <li>Bahasa</li>
        <li>Zona waktu</li>
      </PolicyHyphenList>
      <PolicyText>
        Data yang sebenarnya dikumpulkan dapat berbeda tergantung pada fitur
        yang digunakan dan metode pendaftaran akun.
      </PolicyText>

      <PolicyArticleTitle>
        1.2 Informasi Login melalui Layanan Pihak Ketiga
      </PolicyArticleTitle>
      <PolicyText>
        Pengguna dapat membuat akun atau masuk menggunakan:
      </PolicyText>
      <PolicyHyphenList>
        <li>Google</li>
        <li>Apple</li>
      </PolicyHyphenList>
      <PolicyText>
        Saat menggunakan layanan login pihak ketiga, kami dapat menerima
        informasi berikut dari penyedia layanan tersebut:
      </PolicyText>
      <PolicyHyphenList>
        <li>Pengenal akun (ID)</li>
        <li>Nama atau nama tampilan</li>
      </PolicyHyphenList>
      <PolicyText>
        Informasi yang kami terima dapat berbeda tergantung pada penyedia
        layanan dan pengaturan pengguna pada layanan tersebut.
      </PolicyText>
      <PolicyText>
        Pemrosesan informasi oleh masing-masing penyedia layanan login tunduk
        pada kebijakan privasi penyedia tersebut.
      </PolicyText>

      <PolicyArticleTitle>
        1.3 Data Kesehatan, Persiapan Kehamilan, Kehamilan, dan Kesejahteraan
      </PolicyArticleTitle>
      <PolicyText>
        Beberapa fitur Layanan memungkinkan pengguna untuk secara sukarela
        memasukkan informasi terkait kesehatan, persiapan kehamilan, kehamilan,
        dan kesejahteraan.
      </PolicyText>
      <PolicyText>
        Tergantung pada fitur yang digunakan, informasi tersebut dapat mencakup:
      </PolicyText>

      <PolicyList>
        <li>
          <strong>Persiapan Kehamilan</strong>
          <PolicyHyphenList>
            <li>Periode dan siklus menstruasi</li>
            <li>Tanggal menstruasi terakhir</li>
            <li>Tanggal mulai dan berakhirnya menstruasi</li>
            <li>Tanggal ovulasi</li>
            <li>Tanggal dan waktu tes ovulasi</li>
            <li>Gambar dan hasil tes ovulasi</li>
            <li>Tanggal dan waktu tes kehamilan</li>
            <li>Gambar dan hasil tes kehamilan</li>
            <li>Suhu basal tubuh</li>
            <li>Gejala</li>
            <li>Catatan nyeri dan perdarahan</li>
            <li>Catatan penggunaan obat</li>
            <li>Catatan vaksinasi</li>
            <li>Catatan kunjungan atau pemeriksaan medis</li>
            <li>Catatan aktivitas seksual</li>
            <li>
              Catatan dan informasi jurnal lainnya yang dimasukkan oleh pengguna
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>Perawatan Kesuburan</strong>
          <PolicyHyphenList>
            <li>Jenis perawatan kesuburan</li>
            <li>Siklus dan jumlah perawatan</li>
            <li>Tanggal mulai dan berakhirnya perawatan</li>
            <li>Catatan penggunaan obat dan suntikan</li>
            <li>Jadwal dan rincian perawatan</li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>Kehamilan</strong>
          <PolicyHyphenList>
            <li>Perkiraan tanggal persalinan</li>
            <li>Nama panggilan janin</li>
            <li>Usia kehamilan</li>
            <li>Informasi jurnal kehamilan</li>
            <li>Catatan kunjungan atau pemeriksaan medis</li>
            <li>Catatan vaksinasi</li>
            <li>Catatan berat badan</li>
            <li>Gambar USG</li>
            <li>Pengukuran janin seperti EFW, AC, FL, BPD, HC, dan CRL</li>
            <li>Tinggi dan berat badan sebelum hamil</li>
            <li>Riwayat perubahan berat badan</li>
            <li>
              Informasi lain terkait kehamilan yang dimasukkan oleh pengguna
            </li>
          </PolicyHyphenList>
        </li>
        <li>
          <strong>Perawatan Anak dan Pengelolaan Pascapersalinan</strong>
          <br />
          Tergantung pada fitur yang digunakan, kami dapat mengumpulkan
          informasi berikut mengenai anak:
          <PolicyHyphenList>
            <li>Nama anak</li>
            <li>Jenis kelamin</li>
            <li>Tanggal lahir</li>
            <li>Berat badan saat lahir</li>
            <li>Panjang atau tinggi badan saat lahir</li>
            <li>Lingkar kepala saat lahir</li>
            <li>Perkiraan tanggal persalinan</li>
            <li>Catatan pemeriksaan kesehatan</li>
            <li>Catatan vaksinasi</li>
            <li>
              Data pertumbuhan seperti tinggi badan, berat badan, dan lingkar
              kepala
            </li>
            <li>Catatan dan skor penilaian perkembangan</li>
            <li>Foto terkait perkembangan</li>
            <li>Informasi mengenai kelahiran prematur</li>
            <li>Catatan suhu tubuh</li>
            <li>Catatan penggunaan obat</li>
            <li>Informasi mengenai penyakit</li>
          </PolicyHyphenList>
          Untuk fitur pengelolaan berat badan pascapersalinan, kami juga dapat
          mengumpulkan:
          <PolicyHyphenList>
            <li>Tinggi dan berat badan sebelum hamil</li>
            <li>Berat badan sebelum persalinan</li>
            <li>Catatan berat badan pascapersalinan</li>
          </PolicyHyphenList>
          Beberapa informasi di atas, khususnya data kesehatan, dapat
          dikategorikan sebagai{" "}
          <strong>Data Pribadi yang bersifat spesifik</strong> berdasarkan hukum
          yang berlaku.
          <br />
          Jika diwajibkan oleh hukum, kami akan memperoleh persetujuan yang
          tegas atau terpisah dari pengguna sebelum mengumpulkan atau memproses
          data tersebut.
        </li>
      </PolicyList>

      <PolicyArticleTitle>
        1.4 Informasi dari Fitur Komunitas
      </PolicyArticleTitle>
      <PolicyText>
        Saat pengguna menggunakan fitur komunitas{" "}
        <strong>pregnancy&amp;baby</strong>, kami dapat memproses:
      </PolicyText>
      <PolicyHyphenList>
        <li>Nama panggilan</li>
        <li>Foto profil</li>
        <li>Postingan</li>
        <li>Komentar</li>
        <li>Voting dan jawaban voting</li>
        <li>
          Foto dan konten lain yang secara sukarela diposting oleh pengguna
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Informasi yang diposting di area komunitas dapat terlihat oleh pengguna
        lain. Pengguna harus berhati-hati ketika mengungkapkan Data Pribadi di
        area yang dapat diakses publik.
      </PolicyText>

      <PolicyArticleTitle>
        1.5 Data yang Dikumpulkan Secara Otomatis
      </PolicyArticleTitle>
      <PolicyText>
        Saat pengguna menggunakan Layanan, informasi teknis dan penggunaan
        tertentu dapat dikumpulkan secara otomatis, termasuk:
      </PolicyText>
      <PolicyHyphenList>
        <li>Jenis dan model perangkat</li>
        <li>Sistem operasi dan versinya</li>
        <li>Versi aplikasi</li>
        <li>Bahasa</li>
        <li>Zona waktu</li>
        <li>Alamat IP</li>
        <li>Informasi penggunaan dan aktivitas dalam aplikasi</li>
        <li>Fitur yang diakses atau digunakan</li>
        <li>Frekuensi penggunaan</li>
        <li>Informasi interaksi dengan fitur</li>
        <li>Data kesalahan dan diagnostik</li>
        <li>
          Token registrasi FCM atau token lain yang diperlukan untuk mengirim
          notifikasi push
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Situs web kami juga dapat menggunakan cookie atau teknologi serupa
        apabila diperlukan.
      </PolicyText>

      <PolicyArticleTitle>1.6 Data Analitik</PolicyArticleTitle>
      <PolicyText>
        Kami menggunakan <strong>Google Analytics for Firebase</strong> untuk
        memahami bagaimana pengguna menggunakan Layanan serta meningkatkan
        fungsi dan pengalaman pengguna.
      </PolicyText>
      <PolicyText>Data analitik dapat mencakup:</PolicyText>
      <PolicyHyphenList>
        <li>Informasi penggunaan aplikasi</li>
        <li>Informasi sesi</li>
        <li>Aktivitas dan interaksi dengan fitur</li>
        <li>Informasi perangkat dan sistem operasi</li>
        <li>Informasi teknis dan diagnostik umum</li>
      </PolicyHyphenList>

      <PolicySectionTitle>2. Tujuan Pemrosesan Data Pribadi</PolicySectionTitle>
      <PolicyText>
        Kami memproses Data Pribadi hanya sejauh diperlukan untuk tujuan yang
        jelas dan sah, termasuk:
      </PolicyText>
      <PolicyHyphenList>
        <li>Membuat, mengautentikasi, dan mengelola akun</li>
        <li>Menyediakan dan mengoperasikan Layanan</li>
        <li>
          Memprediksi periode menstruasi berikutnya, masa subur, dan tanggal
          ovulasi
        </li>
        <li>Mencatat dan menganalisis hasil tes ovulasi dan tes kehamilan</li>
        <li>Mengelola jadwal dan pengingat perawatan kesuburan</li>
        <li>Menghitung usia kehamilan dan perkiraan tanggal persalinan</li>
        <li>Menyediakan konten dan laporan terkait kehamilan</li>
        <li>Menganalisis pengukuran pertumbuhan janin</li>
        <li>
          Menyediakan fitur pengelolaan berat badan selama kehamilan dan
          pascapersalinan
        </li>
        <li>Menyediakan laporan pertumbuhan dan perkembangan anak</li>
        <li>
          Menyediakan fitur pengelolaan kesehatan, suhu tubuh, penggunaan obat,
          vaksinasi, dan pemeriksaan kesehatan anak
        </li>
        <li>
          Menyediakan konten dan layanan yang dipersonalisasi berdasarkan
          informasi yang diberikan pengguna
        </li>
        <li>Mengirim pengingat dan notifikasi push</li>
        <li>Menanggapi pertanyaan dan memberikan dukungan pelanggan</li>
        <li>Menjaga keamanan dan integritas Layanan</li>
        <li>Mendeteksi dan mencegah penggunaan atau akses yang tidak sah</li>
        <li>Memantau kinerja dan kesalahan aplikasi</li>
        <li>Menganalisis penggunaan Layanan</li>
        <li>Meningkatkan Layanan yang ada dan mengembangkan fitur baru</li>
        <li>
          Melakukan analisis statistik dan penelitian ilmiah menggunakan data
          yang telah dianonimkan
        </li>
        <li>
          Mematuhi hukum dan menanggapi permintaan yang sah dari otoritas yang
          berwenang
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Kami tidak menjual atau menyewakan Data Pribadi pengguna.
      </PolicyText>

      <PolicySectionTitle>
        3. Data Kesehatan dan Data Pribadi yang Bersifat Spesifik
      </PolicySectionTitle>
      <PolicyText>
        <strong>pregnancy&amp;baby</strong> menyediakan fitur yang berkaitan
        dengan persiapan kehamilan, menstruasi, perawatan kesuburan, kehamilan,
        kesehatan ibu, dan perawatan anak.
      </PolicyText>
      <PolicyText>
        Oleh karena itu, beberapa informasi yang diberikan pengguna dapat
        termasuk dalam kategori{" "}
        <strong>Data Pribadi yang bersifat spesifik</strong>, termasuk data dan
        informasi kesehatan, berdasarkan peraturan perlindungan Data Pribadi
        Indonesia yang berlaku.
      </PolicyText>
      <PolicyText>
        Kami hanya memproses informasi tersebut untuk menyediakan fitur yang
        dipilih pengguna, untuk tujuan yang dijelaskan dalam Kebijakan ini atau
        diberitahukan kepada pengguna dengan cara lain, serta sejauh diizinkan
        oleh hukum.
      </PolicyText>
      <PolicyText>
        Jika hukum mewajibkan persetujuan untuk pengumpulan atau pemrosesan data
        kesehatan atau Data Pribadi yang bersifat spesifik lainnya, kami akan
        memperoleh persetujuan yang diperlukan dari pengguna.
      </PolicyText>
      <PolicyText>
        Kami tidak menjual data kesehatan atau Data Pribadi yang bersifat
        spesifik milik pengguna.
      </PolicyText>

      <PolicySectionTitle>
        4. Analisis Otomatis dan Layanan yang Dipersonalisasi
      </PolicySectionTitle>
      <PolicyText>
        Beberapa fitur <strong>pregnancy&amp;baby</strong> menganalisis
        informasi yang diberikan pengguna untuk memberikan hasil yang
        disesuaikan dengan pengguna.
      </PolicyText>
      <PolicyText>
        Sebagai contoh, kami dapat menganalisis data untuk:
      </PolicyText>
      <PolicyHyphenList>
        <li>Memprediksi periode menstruasi berikutnya dan masa subur</li>
        <li>Memprediksi tanggal ovulasi</li>
        <li>Menganalisis gambar tes ovulasi atau tes kehamilan</li>
        <li>Menghitung perkembangan kehamilan</li>
        <li>Menganalisis pengukuran pertumbuhan janin</li>
        <li>Menganalisis perubahan berat badan ibu</li>
        <li>Menganalisis pertumbuhan dan perkembangan anak</li>
      </PolicyHyphenList>
      <PolicyText>
        Hasil analisis tersebut diberikan untuk tujuan informasi dan dukungan
        kepada pengguna dalam Layanan dan tidak dimaksudkan untuk menggantikan
        diagnosis, perawatan, atau nasihat medis dari dokter atau tenaga
        kesehatan profesional.
      </PolicyText>

      <PolicySectionTitle>
        5. Notifikasi Push dan Pemberitahuan Lainnya
      </PolicySectionTitle>
      <PolicyText>
        Berdasarkan persetujuan atau pengaturan pengguna, kami dapat mengirimkan
        notifikasi push mengenai:
      </PolicyText>
      <PolicyHyphenList>
        <li>Pengingat penggunaan Layanan</li>
        <li>Pengingat jurnal dan catatan kesehatan</li>
        <li>Informasi terkait kehamilan atau perawatan anak</li>
        <li>Pembaruan Layanan</li>
        <li>
          Acara, promosi, atau informasi lain yang secara terpisah telah
          disetujui pengguna untuk diterima
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Untuk mengirim notifikasi push, kami memproses token registrasi FCM atau
        token lain yang setara.
      </PolicyText>
      <PolicyText>
        Pengguna dapat mengubah pengaturan notifikasi kapan saja melalui Layanan
        atau pengaturan perangkat.
      </PolicyText>
      <PolicyText>
        Meskipun pengguna menonaktifkan notifikasi opsional, kami masih dapat
        menyampaikan pemberitahuan penting yang diperlukan untuk menyediakan
        Layanan sejauh diizinkan oleh hukum.
      </PolicyText>

      <PolicySectionTitle>6. Cookie dan Teknologi Serupa</PolicySectionTitle>
      <PolicyText>
        Situs web kami dapat menggunakan cookie dan teknologi serupa apabila
        diperlukan untuk mengoperasikan Layanan, menyimpan pengaturan, memahami
        penggunaan Layanan, dan meningkatkan pengalaman pengguna.
      </PolicyText>
      <PolicyText>
        Pengguna dapat mengelola cookie melalui pengaturan browser. Namun, jika
        cookie tertentu dinonaktifkan, beberapa fungsi situs web mungkin tidak
        berfungsi sebagaimana mestinya.
      </PolicyText>

      <PolicySectionTitle>7. Penyedia Layanan Eksternal</PolicySectionTitle>
      <PolicyText>
        Kami menggunakan penyedia layanan eksternal untuk mengoperasikan,
        memelihara, menganalisis, dan meningkatkan Layanan.
      </PolicyText>
      <PolicyTable>
        <caption className="hide">
          Kategori, Penyedia, Data yang Terkait, Tujuan
        </caption>
        <colgroup>
          <col style={{ width: "20%" }} />
          <col style={{ width: "20%" }} />
          <col />
          <col style={{ width: "25%" }} />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">Kategori</th>
            <th scope="col">Penyedia</th>
            <th scope="col">Data yang Terkait</th>
            <th scope="col">Tujuan</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Infrastruktur dan penyimpanan</td>
            <td>Amazon Web Services (AWS)</td>
            <td className="cell_left">
              Data Pribadi yang diproses melalui Layanan
            </td>
            <td className="cell_left">Hosting dan penyimpanan data</td>
          </tr>
          <tr>
            <td>Komunikasi</td>
            <td>NHN Cloud</td>
            <td className="cell_left">
              Informasi kontak dan data terkait komunikasi
            </td>
            <td className="cell_left">
              Pengiriman pesan dan pemberitahuan layanan
            </td>
          </tr>
          <tr>
            <td>Analitik</td>
            <td>Google Analytics for Firebase</td>
            <td className="cell_left">Data penggunaan dan analitik aplikasi</td>
            <td className="cell_left">Analisis dan peningkatan Layanan</td>
          </tr>
          <tr>
            <td>Pemrosesan gambar</td>
            <td>Google Cloud Vision</td>
            <td className="cell_left">
              Gambar yang diunggah untuk fitur analisis gambar
            </td>
            <td className="cell_left">Analisis gambar dan penyediaan fitur</td>
          </tr>
          <tr>
            <td>Pemantauan aplikasi</td>
            <td>Sentry</td>
            <td className="cell_left">
              Log aplikasi, data kesalahan, dan diagnostik
            </td>
            <td className="cell_left">
              Pemantauan kinerja dan pelacakan kesalahan
            </td>
          </tr>
        </tbody>
      </PolicyTable>
      <PolicyText>
        Penyedia layanan eksternal hanya memproses data sejauh diperlukan untuk
        menyediakan layanan kepada kami dan tunduk pada kewajiban kontraktual
        serta hukum yang berlaku.
      </PolicyText>
      <PolicyText>
        Daftar penyedia layanan dapat berubah seiring dengan pembaruan atau
        perubahan Layanan.
      </PolicyText>

      <PolicySectionTitle>
        8. Kapan Kami Membagikan atau Mengungkapkan Data Pribadi
      </PolicySectionTitle>
      <PolicyText>
        Kami tidak menjual atau menyewakan Data Pribadi pengguna.
      </PolicyText>
      <PolicyText>
        Kami hanya dapat membagikan atau mengungkapkan Data Pribadi sejauh
        diperlukan dalam keadaan seperti:
      </PolicyText>
      <PolicyHyphenList>
        <li>
          Kepada penyedia layanan eksternal yang memproses data untuk mendukung
          operasional kami
        </li>
        <li>Ketika pengguna meminta atau menyetujui pengungkapan tersebut</li>
        <li>
          Ketika diperlukan untuk mematuhi hukum, perintah pengadilan, atau
          permintaan yang sah dari otoritas yang berwenang
        </li>
        <li>
          Ketika secara wajar diperlukan untuk melindungi hak, keselamatan, atau
          keamanan pengguna, pengguna lain, Perusahaan, atau Layanan
        </li>
        <li>
          Dalam hal merger, akuisisi, restrukturisasi, pembiayaan, pengalihan
          bisnis atau aset, atau transaksi korporasi serupa sejauh diizinkan
          oleh hukum
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Informasi yang telah dianonimkan secara permanen dan tidak dapat
        dikembalikan sehingga seseorang tidak dapat diidentifikasi secara wajar
        dapat digunakan atau dibagikan sesuai dengan hukum yang berlaku.
      </PolicyText>

      <PolicySectionTitle>
        9. Data Anonim dan Penggunaan untuk Penelitian
      </PolicySectionTitle>
      <PolicyText>
        Kami dapat menganonimkan data tertentu yang dihasilkan melalui
        penggunaan Layanan untuk tujuan statistik, analisis, penelitian ilmiah,
        dan peningkatan Layanan.
      </PolicyText>
      <PolicyText>
        Penelitian tersebut dapat berkaitan dengan kesehatan perempuan,
        persiapan kehamilan, kehamilan, kesehatan ibu, serta pertumbuhan dan
        perkembangan anak.
      </PolicyText>
      <PolicyText>Proses anonimisasi kami bertujuan untuk:</PolicyText>
      <PolicyHyphenList>
        <li>
          Memastikan pengguna tidak dapat diidentifikasi secara wajar dari data
        </li>
        <li>
          Menghapus pengenal yang dapat menghubungkan data dengan akun pengguna
        </li>
        <li>
          Mencegah data anonim dihubungkan kembali dengan akun atau Data Pribadi
          pengguna
        </li>
        <li>
          Memastikan bahwa kami tidak dapat mengidentifikasi kembali pengguna
          dari data yang telah dianonimkan
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Data yang telah dianonimkan secara permanen dan tidak dapat dipulihkan
        akan diproses sesuai dengan hukum yang berlaku.
      </PolicyText>
      <PolicyText>
        <strong>
          Data anonim dapat disimpan tanpa batas waktu untuk tujuan penelitian,
          statistik, analisis, dan peningkatan Layanan
        </strong>
        .
      </PolicyText>
      <PolicyText>
        Apabila seseorang tidak dapat diidentifikasi secara wajar, kami dapat
        menggunakan atau membagikan data anonim, data agregat, atau hasil
        penelitian dengan lembaga penelitian atau mitra lainnya.
      </PolicyText>

      <PolicySectionTitle>
        10. Jangka Waktu Penyimpanan Data Pribadi dan Penghapusan Akun
      </PolicySectionTitle>
      <PolicyText>
        Kami menyimpan Data Pribadi yang dapat mengidentifikasi pengguna hanya
        selama jangka waktu yang secara wajar diperlukan untuk menyediakan
        Layanan, mencapai tujuan yang dijelaskan dalam Kebijakan ini, atau
        memenuhi kewajiban hukum.
      </PolicyText>
      <PolicyList>
        <li>
          <strong>Penghapusan Akun</strong>
          <br />
          Pengguna dapat menghapus akun melalui fitur penghapusan akun/berhenti
          menjadi anggota dalam Layanan atau dengan mengajukan permintaan kepada
          kami.
          <br />
          Ketika akun dihapus:
          <PolicyHyphenList>
            <li>Akun pengguna akan dihentikan.</li>
            <li>
              Data Pribadi yang dapat mengidentifikasi pengguna akan dihapus
              atau dimusnahkan sesuai dengan hukum yang berlaku.
            </li>
            <li>
              Jika pengguna membuat akun baru di kemudian hari, Data Pribadi
              dari akun sebelumnya tidak akan dipulihkan atau digunakan kembali.
            </li>
          </PolicyHyphenList>
          Namun, kami dapat menyimpan informasi tertentu selama jangka waktu
          yang diperlukan apabila diwajibkan atau diizinkan oleh hukum, misalnya
          untuk memenuhi kewajiban hukum, menyelesaikan sengketa, mencegah
          penipuan, atau melaksanakan hak berdasarkan kontrak.
          <br />
          Sebagaimana dijelaskan dalam Bagian 9, sebagian data terkait
          penggunaan Layanan dapat{" "}
          <strong>
            dianonimkan secara permanen dan tidak dapat dikembalikan
          </strong>{" "}
          sebelum atau selama proses penghapusan akun dan disimpan tanpa batas
          waktu untuk tujuan penelitian, statistik, analisis, dan peningkatan
          Layanan. Data anonim tersebut tidak dapat dihubungkan kembali dengan
          pengguna.
        </li>
        <li>
          <strong>Penghapusan Aplikasi</strong>
          <br />
          Menghapus aplikasi <strong>pregnancy&amp;baby</strong> dari perangkat
          tidak secara otomatis menghapus akun atau Data Pribadi pengguna.
          <br />
          Untuk menghapus Data Pribadi, pengguna harus menghapus akun melalui
          Layanan atau mengajukan permintaan penghapusan kepada kami.
        </li>
      </PolicyList>

      <PolicySectionTitle>11. Hak Subjek Data Pribadi</PolicySectionTitle>
      <PolicyText>
        Sesuai dengan hukum yang berlaku, pengguna dapat memiliki hak terkait
        Data Pribadi mereka, termasuk:
      </PolicyText>
      <PolicyHyphenList>
        <li>
          Hak untuk memperoleh informasi mengenai identitas, dasar kepentingan
          hukum, tujuan permintaan dan penggunaan Data Pribadi, serta
          akuntabilitas pihak yang meminta Data Pribadi
        </li>
        <li>
          Hak untuk melengkapi, memperbarui, dan/atau memperbaiki Data Pribadi
        </li>
        <li>Hak untuk mengakses dan memperoleh salinan Data Pribadi</li>
        <li>
          Hak untuk mengakhiri pemrosesan, menghapus, dan/atau memusnahkan Data
          Pribadi dalam keadaan yang diatur oleh hukum
        </li>
        <li>Hak untuk menarik kembali persetujuan yang telah diberikan</li>
        <li>
          Hak untuk mengajukan keberatan atas keputusan yang hanya didasarkan
          pada pemrosesan otomatis yang menimbulkan akibat hukum atau dampak
          signifikan
        </li>
        <li>
          Hak untuk menunda atau membatasi pemrosesan Data Pribadi dalam keadaan
          yang ditentukan oleh hukum
        </li>
        <li>
          Hak untuk mengajukan gugatan dan menerima ganti rugi atas pelanggaran
          pemrosesan Data Pribadi sesuai hukum
        </li>
        <li>
          Hak untuk memperoleh dan/atau menggunakan Data Pribadi dalam format
          yang lazim digunakan atau dapat dibaca oleh sistem elektronik, apabila
          berlaku
        </li>
        <li>Hak lain yang diberikan berdasarkan hukum yang berlaku</li>
      </PolicyHyphenList>
      <PolicyText>
        Penarikan persetujuan tidak memengaruhi keabsahan pemrosesan yang
        dilakukan sebelum persetujuan ditarik.
      </PolicyText>
      <PolicyText>
        Hak-hak tertentu dapat tunduk pada batasan atau pengecualian berdasarkan
        hukum.
      </PolicyText>
      <PolicyText>
        Untuk menggunakan hak atau mengajukan permintaan terkait Data Pribadi,
        silakan hubungi:
        <br />
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
      </PolicyText>
      <PolicyText>
        Kami dapat meminta informasi yang secara wajar diperlukan untuk
        memverifikasi identitas pemohon sebelum memenuhi permintaan.
      </PolicyText>

      <PolicySectionTitle>12. Keamanan Data Pribadi</PolicySectionTitle>
      <PolicyText>
        Kami menerapkan langkah-langkah teknis dan organisasi yang wajar untuk
        melindungi Data Pribadi dari akses tidak sah, kehilangan, pencurian,
        penyalahgunaan, pengungkapan tanpa izin, perubahan, atau penghancuran.
      </PolicyText>
      <PolicyText>Langkah-langkah tersebut dapat mencakup:</PolicyText>
      <PolicyHyphenList>
        <li>Enkripsi data saat transmisi dan penyimpanan, jika sesuai</li>
        <li>Pengendalian akses</li>
        <li>Pemantauan sistem</li>
        <li>Pengelolaan kerentanan keamanan</li>
        <li>Prosedur keamanan internal</li>
        <li>
          Pembatasan akses terhadap Data Pribadi berdasarkan kebutuhan pekerjaan
        </li>
      </PolicyHyphenList>
      <PolicyText>
        Akses terhadap Data Pribadi hanya diberikan kepada personel yang
        memerlukannya untuk menjalankan tugas mereka.
      </PolicyText>
      <PolicyText>
        Namun, tidak ada metode transmisi atau penyimpanan elektronik yang dapat
        dijamin sepenuhnya aman.
      </PolicyText>
      <PolicyText>
        Jika terjadi insiden atau pelanggaran Data Pribadi, kami akan mengambil
        tindakan yang sesuai dan memberikan pemberitahuan atau laporan kepada
        pengguna dan/atau otoritas yang berwenang apabila diwajibkan oleh hukum.
      </PolicyText>

      <PolicySectionTitle>
        13. Lokasi Penyimpanan dan Transfer Data Pribadi ke Luar Indonesia
      </PolicySectionTitle>
      <PolicyText>
        Connecti Co., Ltd. berlokasi di <strong>Republik Korea</strong>.
      </PolicyText>
      <PolicyText>
        Infrastruktur aplikasi utama dan penyimpanan data Layanan menggunakan{" "}
        <strong>
          Amazon Web Services (AWS), Region Asia Pasifik (Seoul), Republik
          Korea.
        </strong>
      </PolicyText>
      <PolicyText>
        Dengan demikian, Data Pribadi pengguna di Indonesia dapat disimpan dan
        diproses di Republik Korea.
      </PolicyText>
      <PolicyText>
        Selain itu, karena <strong>pregnancy&amp;baby</strong> menggunakan
        penyedia layanan global, sebagian Data Pribadi atau informasi teknis
        dapat diproses oleh atau diakses oleh penyedia layanan yang berada di
        negara selain negara tempat tinggal pengguna.
      </PolicyText>
      <PolicyText>Penyedia tersebut dapat mencakup:</PolicyText>
      <PolicyHyphenList>
        <li>Amazon Web Services</li>
        <li>Google</li>
        <li>NHN Cloud</li>
        <li>Sentry</li>
      </PolicyHyphenList>
      <PolicyText>
        Dalam melakukan transfer Data Pribadi ke luar Indonesia, kami akan
        mematuhi ketentuan hukum perlindungan Data Pribadi Indonesia yang
        berlaku, termasuk persyaratan mengenai tingkat perlindungan Data Pribadi
        yang setara atau lebih tinggi, perlindungan yang memadai dan mengikat,
        persetujuan pengguna, atau mekanisme lain yang diperbolehkan oleh hukum,
        sebagaimana berlaku.
      </PolicyText>

      <PolicySectionTitle>
        14. Data Pribadi Anak di Bawah Umur
      </PolicySectionTitle>
      <PolicyText>
        Layanan ini ditujukan kepada individu yang telah mencapai usia di mana
        mereka dapat{" "}
        <strong>
          memberikan persetujuan yang sah secara mandiri atas pengumpulan dan
          pemrosesan Data Pribadi mereka
        </strong>{" "}
        berdasarkan hukum yang berlaku.
      </PolicyText>
      <PolicyText>
        Jika hukum mengharuskan persetujuan orang tua, wali, atau perwakilan
        hukum untuk menggunakan Layanan atau memproses Data Pribadi, individu
        yang belum memperoleh persetujuan yang diperlukan tersebut tidak
        diperbolehkan membuat atau menggunakan akun{" "}
        <strong>pregnancy&amp;baby</strong>.
      </PolicyText>
      <PolicyText>
        Kami tidak dengan sengaja mengumpulkan Data Pribadi dari individu yang
        belum dapat memberikan persetujuan yang sah secara mandiri dan belum
        memperoleh persetujuan yang diperlukan dari orang tua, wali, atau
        perwakilan hukum.
      </PolicyText>
      <PolicyText>
        Jika Anda meyakini bahwa Data Pribadi anak di bawah umur telah diberikan
        kepada kami dengan cara yang tidak sesuai dengan hukum, silakan hubungi{" "}
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
        . Kami akan meninjau masalah tersebut dan mengambil tindakan yang
        sesuai, termasuk menghapus data apabila diperlukan.
      </PolicyText>

      <PolicySectionTitle>
        15. Data Pribadi Anak yang Didaftarkan oleh Pengguna
      </PolicySectionTitle>
      <PolicyText>
        Beberapa fitur perawatan anak memungkinkan orang tua, wali, perwakilan
        hukum, atau pihak lain yang memiliki kewenangan berdasarkan hukum untuk
        memasukkan informasi mengenai anak.
      </PolicyText>
      <PolicyText>Informasi tersebut dapat mencakup:</PolicyText>
      <PolicyHyphenList>
        <li>Nama</li>
        <li>Jenis kelamin</li>
        <li>Tanggal lahir</li>
        <li>Pengukuran tubuh saat lahir</li>
        <li>Data pertumbuhan</li>
        <li>Data perkembangan</li>
        <li>Informasi pemeriksaan kesehatan</li>
        <li>Informasi vaksinasi</li>
        <li>Suhu tubuh</li>
        <li>Informasi penggunaan obat</li>
        <li>Informasi penyakit</li>
        <li>Foto terkait</li>
      </PolicyHyphenList>
      <PolicyText>
        Dengan memasukkan Data Pribadi anak ke dalam Layanan, pengguna
        menyatakan bahwa mereka memiliki kewenangan yang sah untuk memberikan
        dan mengelola data tersebut sebagai orang tua, wali, perwakilan hukum,
        atau pihak lain yang memiliki kewenangan berdasarkan hukum.
      </PolicyText>
      <PolicyText>
        Kami hanya memproses informasi tersebut untuk tujuan yang dijelaskan
        dalam Kebijakan ini dan sejauh diizinkan oleh hukum.
      </PolicyText>

      <PolicySectionTitle>
        16. Layanan Login dan Layanan Pihak Ketiga
      </PolicySectionTitle>
      <PolicyText>
        Saat pengguna masuk ke <strong>pregnancy&amp;baby</strong> menggunakan
        Google, Apple, penggunaan layanan tersebut juga tunduk pada ketentuan
        penggunaan dan kebijakan privasi masing-masing penyedia.
      </PolicyText>
      <PolicyText>
        Layanan kami juga dapat berisi tautan ke situs web, aplikasi, atau
        layanan yang dioperasikan oleh pihak ketiga.
      </PolicyText>
      <PolicyText>
        Kami tidak bertanggung jawab atas praktik pemrosesan Data Pribadi yang
        dilakukan secara independen oleh pihak ketiga. Pengguna disarankan untuk
        meninjau kebijakan privasi pihak ketiga sebelum memberikan Data Pribadi
        kepada mereka.
      </PolicyText>

      <PolicySectionTitle>
        17. Kami Tidak Menjual Data Pribadi
      </PolicySectionTitle>
      <PolicyText>
        Kami tidak menjual atau menyewakan Data Pribadi pengguna.
      </PolicyText>
      <PolicyText>
        Kami juga tidak menjual Data Pribadi yang berkaitan dengan kesehatan,
        persiapan kehamilan, kehamilan, atau anak.
      </PolicyText>

      <PolicySectionTitle>
        18. Perubahan terhadap Kebijakan Privasi
      </PolicySectionTitle>
      <PolicyText>
        Kami dapat mengubah Kebijakan Privasi ini untuk mencerminkan:
      </PolicyText>
      <PolicyHyphenList>
        <li>Perubahan pada Layanan</li>
        <li>Perubahan dalam cara kami memproses Data Pribadi</li>
        <li>Perubahan penyedia layanan</li>
        <li>Perubahan hukum atau peraturan yang berlaku</li>
      </PolicyHyphenList>
      <PolicyText>
        Jika perubahan tersebut berdampak secara signifikan terhadap hak
        pengguna atau cara kami memproses Data Pribadi, kami akan memberikan
        pemberitahuan yang sesuai sebelum perubahan berlaku sebagaimana
        diwajibkan oleh hukum.
      </PolicyText>
      <PolicyText>
        Jika diwajibkan oleh hukum, kami akan memperoleh persetujuan pengguna
        kembali.
      </PolicyText>
      <PolicyText>
        Tanggal berlaku dan tanggal pembaruan terakhir akan ditampilkan di
        bagian atas Kebijakan ini.
      </PolicyText>

      <PolicySectionTitle>
        19. Hubungi Kami mengenai Data Pribadi
      </PolicySectionTitle>
      <PolicyText>
        Jika Anda memiliki pertanyaan mengenai Kebijakan Privasi ini, cara kami
        memproses Data Pribadi, atau ingin menggunakan hak terkait Data Pribadi,
        silakan hubungi:
      </PolicyText>
      <PolicyText>
        <strong>Connecti Co., Ltd.</strong>
        <br />
        B2F, Unit 56
        <br />
        176 Yanghwa-ro, Mapo-gu
        <br />
        Seoul, Republic of Korea
        <br />
        <strong>Email:</strong>{" "}
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
      </PolicyText>

      <PolicySectionTitle>
        20. Ketentuan untuk Pengguna di Indonesia
      </PolicySectionTitle>
      <PolicyText>
        Untuk Data Pribadi pengguna di Indonesia, kami memproses Data Pribadi
        sesuai dengan{" "}
        <strong>
          Undang-Undang Republik Indonesia Nomor 27 Tahun 2022 tentang
          Pelindungan Data Pribadi (UU PDP)
        </strong>{" "}
        dan peraturan pelaksana serta ketentuan lain yang berlaku.
      </PolicyText>
      <PolicyText>
        Berdasarkan UU PDP, <strong>data dan informasi kesehatan</strong>{" "}
        termasuk dalam kategori{" "}
        <strong>Data Pribadi yang bersifat spesifik</strong> dan memperoleh
        perlindungan khusus.
      </PolicyText>
      <PolicyText>
        Apabila pemrosesan Data Pribadi memerlukan persetujuan berdasarkan hukum
        yang berlaku, kami akan meminta persetujuan yang sah dari pengguna
        sesuai dengan persyaratan hukum.
      </PolicyText>
      <PolicyText>
        Pengguna di Indonesia dapat memiliki hak berdasarkan UU PDP, termasuk
        hak untuk memperoleh informasi, memperbaiki atau memperbarui Data
        Pribadi, mengakses dan memperoleh salinan Data Pribadi, mengakhiri
        pemrosesan dan meminta penghapusan atau pemusnahan dalam keadaan yang
        berlaku, menarik persetujuan, mengajukan keberatan terhadap keputusan
        tertentu yang hanya didasarkan pada pemrosesan otomatis, membatasi
        pemrosesan, serta hak lain yang diberikan oleh hukum.
      </PolicyText>
      <PolicyText>
        Karena infrastruktur utama <strong>pregnancy&amp;baby</strong> berada di
        Republik Korea dan beberapa penyedia layanan dapat memproses data di
        luar Indonesia, Data Pribadi pengguna Indonesia dapat ditransfer ke luar
        wilayah Indonesia.
      </PolicyText>
      <PolicyText>
        Transfer Data Pribadi ke luar Indonesia akan dilakukan sesuai dengan
        persyaratan UU PDP dan peraturan yang berlaku, termasuk dengan
        memastikan tingkat perlindungan yang memadai, menerapkan perlindungan
        yang memadai dan mengikat, memperoleh persetujuan jika diperlukan, atau
        menggunakan mekanisme lain yang diperbolehkan oleh hukum.
      </PolicyText>
      <PolicyText>
        Untuk menggunakan hak sebagai Subjek Data Pribadi atau mengajukan
        pertanyaan mengenai pemrosesan Data Pribadi, silakan hubungi:
        <br />
        <a href="mailto:after10month@connect-i.co.kr">
          after10month@connect-i.co.kr
        </a>
      </PolicyText>
    </PolicyContainer>
  );
};

export default PrivacyId;
